import {
  ALL_MESSAGES_FETCH_SUCCESS,
  ALL_MESSAGES_FETCH_ERROR,
  OUTBOX_FETCH_SUCCESS,
  OUTBOX_FETCH_ERROR,
  CHANGE_READ_STATUS_SUCCESS,
  CHANGE_READ_STATUS_ERROR,
} from './types';
import { baseUrl } from '../constants/baseUrl';

import { fetchWithAccessToken } from './helperAction';

export const fetchInboxMessages = (id) => async (dispatch) => {
  try {
    const response = await dispatch(
      fetchWithAccessToken({
        url: `${baseUrl}message/recipient/${id}`,
        method: 'GET',
      }),
    );
    const messages = await response.json();

    switch (response.status) {
      case 200:
      case 201:
        messages.sort((a, b) => new Date(b.deliverAt) - new Date(a.deliverAt));
        await dispatch({
          type: ALL_MESSAGES_FETCH_SUCCESS,
          payload: messages,
        });
        break;
      default:
        await dispatch({
          type: ALL_MESSAGES_FETCH_ERROR,
        });
    }
  } catch (e) {
    dispatch({ type: ALL_MESSAGES_FETCH_ERROR, payload: e });
  }
};

export const fetchOutboxMessages = (id) => async (dispatch) => {
  try {
    const response = await dispatch(
      fetchWithAccessToken({
        url: `${baseUrl}message/sender/${id}`,
        method: 'GET',
      }),
    );
    const messages = await response.json();

    switch (response.status) {
      case 200:
        messages.sort((a, b) => new Date(b.deliverAt) - new Date(a.deliverAt));
        await dispatch({
          type: OUTBOX_FETCH_SUCCESS,
          payload: messages,
        });
        break;
      default:
        await dispatch({
          type: OUTBOX_FETCH_ERROR,
        });
    }
  } catch (e) {
    dispatch({ type: OUTBOX_FETCH_ERROR, payload: e });
  }
};

export const setMessageToRead = (id) => async (dispatch) => {
  try {
    const read = {
      read: 'true',
    };

    const response = await dispatch(
      fetchWithAccessToken({
        url: `${baseUrl}message/read/${id}`,
        method: 'PUT',
        body: JSON.stringify(read),
      }),
    );

    const body = await response.json();

    switch (response.status) {
      case 200:
      case 201:
        await dispatch({
          type: CHANGE_READ_STATUS_SUCCESS,
          payload: body,
        });
        break;
      default:
        await dispatch({
          type: CHANGE_READ_STATUS_ERROR,
        });
    }

    return body;
  } catch (e) {
    dispatch({
      type: CHANGE_READ_STATUS_ERROR,
      payload: e,
    });
    return { error: 'Something with the read status went wrong.' };
  }
};
